import { combineReducers } from 'redux';
import menu from './menu/reducer';
import auth from '../reducers/auth';
import locus from '../reducers/location';
import company from '../reducers/company';
import project from '../reducers/project';
import feedback from '../reducers/dashboard';
import asset from '../reducers/asset';

const reducers = combineReducers({
  menu,
  auth,locus,company,project,feedback,asset
});

export default reducers;
